/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import classnames from 'classnames';
import * as React from 'react';

/**
 * Configuration for the loading placeholder image.
 */
export interface ILoadingPlaceholderImageProps {
    /**
     * The html class name to use for the html element. Will be used along with the default classes.
     */
    className?: string;
}

/**
 * React component responsible for rendering a loading placeholder image
 * which should be used to be displayed when main image is downloading on the client and is not yet ready to be displayed.
 *
 * The element is an empty div element by default. Use css styles for the class in order to specify the image for the component.
 */
export class LoadingPlaceholderImage extends React.PureComponent<ILoadingPlaceholderImageProps> {
    /**
     * The default class for loading image component.
     */
    private static _loadingImageClassName: string = 'msc-loading_image';

    /**
     * Initializes instance with the given props.
     * @param {ILoadingPlaceholderImageProps} props - Configuration for the loading placeholder image.
     */
    public constructor(props: ILoadingPlaceholderImageProps) {
        super(props);
    }

    /**
     * Renders loading placeholder image.
     *
     * The element is an empty div element by default. Use css styles for the class in order to specify the image for the component.
     */
    public render(): React.ReactNode {
        return <div className={classnames(LoadingPlaceholderImage._loadingImageClassName, this.props.className)} />;
    }
}
